import AssetsService from '@/services/AssetsService';

export default {
  namespaced: true,
  state: () => ({
    assets: [],
  }),
  getters: {
    getAssetById: (state) => (id) => {
      return state.assets.find(asset => asset.id === id);
    },
  },
  mutations: {
    setAssets(state, assets) {
      state.assets = assets;
    },
  },
  actions: {
    async fetchAssetsList ({ commit }) {
      const assetInfo = await AssetsService.getAssetInfo();
      commit('setAssets', assetInfo);
    },
    init ({ dispatch, state }) {
      if (state.assets.length > 0) {
        return;
      }
      dispatch('fetchAssetsList');
    },
  },
};
